module.exports = __webpack_public_path__ + "static/img/polic-log.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/polic-log.png
// module id = 23
// module chunks = 0